// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oxcC","colBig":"styles_colBig__35luw","colSmall":"styles_colSmall__2c71P","shopifyNameWrapper":"styles_shopifyNameWrapper__vv_ZZ"};